import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { AtomicLogo } from "../../../assets/AtomicLogo";

export const AuthenticationLoading = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#fafafa",
      }}
    >
      <Box sx={{ mb: 3 }}>
        <AtomicLogo width={80} height={80} />
      </Box>
      <CircularProgress
        size={60}
        sx={{
          color: "#3877F7",
          mb: 2,
        }}
      />
      <Typography
        variant="h6"
        sx={{
          color: "#333333",
          fontWeight: 300,
        }}
      >
        Authenticating...
      </Typography>
    </Box>
  );
};
